import * as AuthHelper from './APIHelper';

export const PostPasswordEmail = (payload) => {
    return AuthHelper.postResponse('/login/email', payload);
}

export const PostForgotPasswordEmail = (payload) => {
    return AuthHelper.postResponse('/forgotpassword', payload);
}